import { api, time } from "@vuumly-common/common";
import { ChartData, ChartOptions } from "chart.js";
import { useQuery, useTheme, useTimeGranularity, useTranslate } from "hooks";
import _ from "lodash";
import { RoutePathEnum } from "../../../controllers/router";
import { BaseLineChart } from "../../Charts";
import { TimeGranularityTabs } from "../../Tabs/TimeGranularityTabs";
import { TextH5 } from "../../Typography/Text";
import { BaseCard } from "../Base.card";

interface Props {
  href?: RoutePathEnum;
  includeOriginId?: boolean;
  disableLink?: boolean;
  horizontal?: boolean;
  chartHeight?: number;
}

export const FleetSizeNotRentedTimeseriesDeviceTypeCard = (props: Props) => {
  const { tabs, timeGranularity, changeGranularity, modifiedQueryParams } =
    useTimeGranularity();
  const { getDeviceTypeColors } = useTheme();

  const translate = useTranslate();

  const { disableLink = true } = props;

  const { data, isLoading } = useQuery({
    apiEndpoint: api.Endpoint.FleetSizeNotRentedTimeseriesDeviceType,
    params: modifiedQueryParams,
  });

  const clonedData = _.cloneDeep(data) as ChartData<"line">;

  clonedData?.datasets.forEach((dataset) => {
    dataset.label = translate(dataset.dimensions?.device_type || "Device type");
    const colors = getDeviceTypeColors(dataset.dimensions?.device_type);
    dataset.backgroundColor = colors.color;
    dataset.borderColor = colors.color;
  });

  const options: ChartOptions<"line"> = {
    parsing: {
      xAxisKey: "date",
      yAxisKey: "device_count",
    },

    scales: {
      x: {
        type: "timeseries",
      },
      y: {
        title: {
          text: "Fleet size",
        },
      },
    },
  };

  const Header = () => {
    return (
      <div className="flex justify-between w-full">
        <TextH5>{translate("Average fleet size on standby over time")}</TextH5>
        <TimeGranularityTabs
          tabs={tabs}
          defaultValue={timeGranularity || time.GranularityEnum.Day}
          onChange={changeGranularity}
        />
      </div>
    );
  };

  return (
    <BaseCard
      isLoading={isLoading}
      header={<Header />}
      href={disableLink ? undefined : RoutePathEnum.Rides}
    >
      <div>
        <BaseLineChart options={options} data={clonedData} />
      </div>
    </BaseCard>
  );
};
